"use strict";

exports.__esModule = true;
exports["default"] = Wearables;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Wearables(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M438 164.9c0-40-27.7-72.9-72.8-72.9H146.8C101.7 92 74 124.8 74 164.9v182.2c0 40 27.7 72.9 72.8 72.9h218.4c45.1 0 72.8-32.8 72.8-72.9V164.9zm-36.4 163.9c0 31.9-18.7 54.7-54.6 54.7H165c-35.9 0-54.6-22.8-54.6-54.6V183.1c0-31.9 18.8-54.6 54.6-54.6h182c35.9 0 54.6 22.8 54.6 54.6v145.7zM328.8 1H183.2c-35.4 0-72.8 32-72.8 72.9h291.2C401.6 33 364.3 1 328.8 1zM183.2 511h145.6c35.4 0 72.8-31.9 72.8-72.8H110.4c0 40.8 37.3 72.8 72.8 72.8zm91-236.8l-36.4-109.3-36.4 72.9h-72.8V256h91l18.2-36.4 36.4 109.3 36.4-72.9h72.8v-18.2l-89.3-2.9-19.9 39.3z"
  }));
}